import React, { useState , useEffect } from 'react'
import SideMenu from './layouts/SideMenu'
import TopBar from './layouts/TopBar'
import MobileMenu from './layouts/MobileMenu'
import { DataGrid } from '@mui/x-data-grid';
import GeneralReport from './layouts/GeneralReport';
import EditIcon from '@mui/icons-material/Edit';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Modal } from '@mui/material';
import './cssClasses/custom.css'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BASE_URL, getBearerToken, postBearerToken, putBearerToken } from '../../utils/Apis';
import { useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import axios from 'axios';
import { Constants } from '../../utils/Constants';

const A_messages = () => {

    const location = useLocation()
    console.log(location)
    // React.useEffect(() => {
    //     const LoadExternalScript = () => {
    //         const externalScript = document.createElement("script");
    //         // externalScript.onerror = loadError;
    //         externalScript.id = "external";
    //         externalScript.async = true;
    //         externalScript.type = "text/javascript";
    //         externalScript.setAttribute("crossorigin", "anonymous");
    //         document.body.appendChild(externalScript);
    //         externalScript.src = '../dist/js/app.js';
    //     };
    //     LoadExternalScript();
    //     return () => {
    //         // document.body.removeChild(externalScript);
    //     };
    // }, []);


    
    const [hostmessage, sethostmessage] = useState("")
    

    const [message, setmessage] = useState("")
    const [messageView, setmessageView] = useState(false)
    const [loader, setloader] = useState(false)
    const [fetchLoader, setfetchLoader] = useState(false)

   

    const submit = async () => {
        setloader(true)

        postBearerToken("messages", { "message": hostmessage }).then((result) => {
            if (result.error == 0) {
                setloader(false)
            } else {
                setloader(false)
            }

        })

    }
    const fetchMessages = async () => {
        setloader(true)

        getBearerToken("messages").then((result) => {
            if (result.error == 0) {
                setloader(false)
                console.log(result?.data?.message)
                // if(result.data){
                    sethostmessage(result?.data?.message)
                // }
            } else {
                setloader(false)
            }

        })

    }

    useEffect(() => {
      fetchMessages()
    }, [])
    


    return (
        <div className="py-5 md:py-0">
            {/* <!-- BEGIN: Mobile Menu --> */}
            <div className="mobile-menu md:hidden">
                <MobileMenu />

            </div>
            {/* <!-- END: Mobile Menu -->
        <!-- BEGIN: Top Bar --> */}
            <TopBar />
            {/* <!-- END: Top Bar --> */}
            <div className="flex overflow-hidden">
                {/* <!-- BEGIN: Side Menu --> */}
                <SideMenu />
                {/* <!-- END: Side Menu -->
            <!-- BEGIN: Content --> */}
                <div className="content">
                    <div className="grid grid-cols-12 gap-12">
                        <div className="col-span-12 2xl:col-span-12">
                            <div class="grid grid-cols-12 gap-12 mt-5 w-100">
                                <div class="intro-y col-span-12 lg:col-span-12">

                                    {messageView ?
                                        <div className='w-100' style={{ background: "lightblue", borderWidth: 1, borderRadius: 3, padding: 10, display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: "row" }}>
                                            <label>{message}</label>
                                            <div onClick={() => setmessageView(false)} style={{ cursor: "pointer" }} className="side-menu__icon"> <i data-lucide="x"></i> </div>
                                        </div>
                                        : null}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12 2xl:col-span-12">

                            {/* <div>
                                <img src={BASE_URL+file} style={{width:"80px" , height:"80px"}}></img> 
                            </div> */}

                            {fetchLoader == false ?

                                <div class="grid grid-cols-12 gap-6 mt-5">
                                    <div class="intro-y col-span-12 lg:col-span-12">
                                        <div class="intro-y box p-5">

                                            <div className='mt-2'>
                                                <label style={{ display: "flex", justifyContent: "start" }}>Message</label>
                                                <input id="crud-form-1"
                                                    value={hostmessage}
                                                    onChange={(e) => sethostmessage(e.target.value)}
                                                    type="text" class="form-control w-full" />
                                            </div>

                                            {
                                                loader
                                                    ?
                                                    <div class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center">
                                                        <i data-loading-icon="circles" class="w-8 h-8"></i>
                                                        <div class="text-center text-xs mt-2">Loading</div>
                                                    </div>
                                                    :
                                                    <div class="text-right mt-5">
                                                        {/* <button type="button" class="btn btn-outline-secondary w-24 mr-1">Cancel</button> */}
                                                        <button onClick={() => submit()} type="button" class="btn btn-primary w-24">Save</button>
                                                    </div>
                                            }


                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>

                    </div>
                </div>
                {/* <!-- END: Content --> */}
            </div>


        </div>
    )
}

export default A_messages